import { API_BASE, devSession } from '@platform/dao';
import { HttpClient } from '@platform/dao/HttpClient';
import type { IAssignment, IAttachment } from '@platform/core/types';
import { baseApi, recordTag, run } from '@platform/state/api/baseApi';
import type { IAssignmentPatch } from './IAssignmentPatch';

/**
 * Транспорт дій вкладок, яких ще немає в DAO платформи (той самий базовий URL і заголовки, що й dao: мова, Dev-користувач).
 * Контракт бекенду (CollaborationEndpoints): PATCH/DELETE /records/{id}/assignments/{aid}, PATCH/DELETE /records/{id}/files/{fid}.
 */
const http = new HttpClient({
  baseUrl: API_BASE,
  headers: () => ({ 'Accept-Language': devSession.lang, ...(devSession.user ? { 'X-Dev-User': devSession.user } : {}) }),
});

/** Зміни доручень і файлів запису: кожна оновлює свій список та історію запису, вилучення — ще й лічильники конверта запису. */
export const recordTabsApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    updateAssignment: b.mutation<IAssignment, { recordId: string; assignmentId: string; body: IAssignmentPatch }>({
      queryFn: ({ recordId, assignmentId, body }) => run(() => http.patch<IAssignment>(`/records/${recordId}/assignments/${assignmentId}`, body)),
      invalidatesTags: (_r, _e, { recordId }) => [{ type: 'Assignments', id: recordId }, { type: 'History', id: recordId }, 'Inbox'],
    }),
    removeAssignment: b.mutation<void, { recordId: string; rt: string; assignmentId: string }>({
      queryFn: ({ recordId, assignmentId }) => run(() => http.delete(`/records/${recordId}/assignments/${assignmentId}`)),
      invalidatesTags: (_r, _e, { recordId, rt }) => [{ type: 'Assignments', id: recordId }, { type: 'History', id: recordId }, recordTag(rt, recordId), 'Inbox'],
    }),
    renameFile: b.mutation<IAttachment, { recordId: string; fileId: string; fileName: string }>({
      queryFn: ({ recordId, fileId, fileName }) => run(() => http.patch<IAttachment>(`/records/${recordId}/files/${fileId}`, { fileName })),
      invalidatesTags: (_r, _e, { recordId }) => [{ type: 'Files', id: recordId }, { type: 'History', id: recordId }],
    }),
    removeFile: b.mutation<void, { recordId: string; rt: string; fileId: string }>({
      queryFn: ({ recordId, fileId }) => run(() => http.delete(`/records/${recordId}/files/${fileId}`)),
      invalidatesTags: (_r, _e, { recordId, rt }) => [{ type: 'Files', id: recordId }, { type: 'History', id: recordId }, recordTag(rt, recordId)],
    }),
  }),
});

export const { useUpdateAssignmentMutation, useRemoveAssignmentMutation, useRenameFileMutation, useRemoveFileMutation } = recordTabsApi;
